module.exports = __webpack_public_path__ + "img/VU.949a64ce.svg";